import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';
import { store } from '../store';
import {
    setCurrentScreenId,
    setCurrentScreenLoading,
    setCurrentScreenName,
    setCurrentScreenState
} from '../containers/Pages/CreateCourse/Slices/currentScreen';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setCurrentSectionId } from '../containers/Pages/CreateCourse/Slices/currentCourse';

export const createManual = async (courseId, title, dispatch) => {
    const response = await axiosAgent.post(
        `${ApiConfig.section.createSection}/${courseId}`,
        { title }
    );
    dispatch(setCurrentSectionId(response.data.data._id));
    dispatch(setCurrentScreenName('lesson'));
    dispatch(setCurrentScreenId(''));
    console.log('Manual created', response.data);
    return response.data.data._id;
};

export const getSectionsOfCourse = async (courseId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.section.getSectionOfCourse}/${courseId}`
    );
    console.log('get Sections response', response);
    return response;
};

export const createLessons = async (formData, courseId, sectionId) => {
    console.log('formdata,courseId,sectionId', formData, courseId, sectionId);
    const response = await axiosAgent.post(
        `${ApiConfig.lecture.createLecture}/${courseId}/${sectionId}`,
        { title: formData.title, description: formData.description }
    );
    console.log('lesson create response', response);
    return response.data.data._id;
};

export const editLesson = async (
    lectureId,
    video,
    lessonFormData,
    dispatch
) => {
    dispatch(setCurrentScreenLoading(true));
    const data = new FormData();
    if (video || video === '') data.append('video', video);
    if (lessonFormData) {
        Object.keys(lessonFormData).map((item) => {
            if (item !== 'video') {
                data.append(item, lessonFormData[item]);
            }
        });
    }
    const response = await axiosAgent.put(
        `${ApiConfig.lecture.editLecture}/${lectureId}`,
        data
    );
    dispatch && dispatch(setCurrentScreenState(true));
    dispatch && dispatch(setCurrentScreenId(lectureId));
    dispatch(setCurrentScreenLoading(false));
    toast.success('lecture created Successfully');
};

export const createResource = async (lectureId, courseId, resource, title) => {
    store.dispatch(setCurrentScreenLoading(true));
    const response = await axiosAgent.post(
        `${ApiConfig.resource.createResource}/${courseId}/${lectureId}`,
        { name: resource.name, resourceTitle: title }
    );
    const resourceId = response.data.data._id;
    store.dispatch(setCurrentScreenLoading(false));
    await editResource(resource, resourceId);
    return response.data.data._id;
};

export const editResource = async (resource, resourceId) => {
    store.dispatch(setCurrentScreenLoading(true));
    const data = new FormData();
    data.append('resource', resource);
    const response = await axiosAgent.put(
        `${ApiConfig.resource.editResource}/${resourceId}`,
        data
    );
    store.dispatch(setCurrentScreenLoading(false));
    console.log('response of editResource', response);
};

export const getCurrentLecture = async (lectureId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.lecture.getIndividualLecture}/${lectureId}`
    );
    return response;
};

export const deleteResources = async (ids, lectureId, dispatch) => {
    dispatch(setCurrentScreenLoading(true));
    const response = await axiosAgent.delete(
        `${ApiConfig.resource.deleteResource}/${lectureId}`,
        { data: { resourcesId: ids } }
    );
    dispatch(setCurrentScreenLoading(false));
    return response.data.data;
};

export const deleteLesson = async (
    lectureId,
    sectionId,
    dispatch,
    setResourceToBeDeletedId
) => {
    dispatch(setCurrentScreenLoading(true));
    await axiosAgent.delete(
        `${ApiConfig.lecture.delete}/${lectureId}/${sectionId}`
    );
    dispatch(setCurrentScreenLoading(false));
    dispatch(setCurrentScreenId(sectionId));
    dispatch(setCurrentScreenName('manual'));
    setResourceToBeDeletedId([]);
};

export const deleteManual = async (sectionId, dispatch) => {
    dispatch(setCurrentScreenLoading(true));
    await axiosAgent.delete(`${ApiConfig.section.delete}/${sectionId}`);
    dispatch(setCurrentScreenLoading(false));
};

export const editManualApi = async (sectionId, title, dispatch) => {
    dispatch(setCurrentScreenLoading(true));
    const response = await axiosAgent.put(
        `${ApiConfig.section.edit}/${sectionId}`,
        { title }
    );
    console.log('Edit manual response', response.data.data._id);
    dispatch(setCurrentScreenLoading(false));
    return response.data.data._id;
};

export const deleteSection = async (sectionId, toast) => {
    const response = await axiosAgent.delete(
        `${ApiConfig.section.deleteSection}/${sectionId}`
    );
    response.data.success && toast.success('Test Toast Success');
    return response;
};

export const getIndividualLectureCompletionStatus = async (
    instructorId,
    courseId
) => {
    const response = await axiosAgent.get(
        `${ApiConfig.lecture.getCompletedLecturesOfCourse}/${instructorId}/${courseId}`
    );
    return response.data.data;
};

export const likeLecture = async (lectureId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.likes.likeLecture}/${lectureId}`
    );
    return response;
};

export const getLikes = async (lectureId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.likes.getLikes}/${lectureId}`
    );
    return response;
};

export const createComment = async (comment, lectureId) => {
    const response = await axiosAgent.post(
        `${ApiConfig.comments.createComment}/${lectureId}`,
        { description: comment }
    );
    return response;
};

export const getAllComments = async (lectureId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.comments.getComments}/${lectureId}`
    );
    return response;
};

export const editComment = async (commentId, data) => {
    const response = await axiosAgent.post(
        `${ApiConfig.comments.updateComment}/${commentId}`,
        { description: data }
    );
    return response;
};

export const createReply = async (commentId, lectureID, data) => {
    const response = await axiosAgent.post(
        `${ApiConfig.comments.replyToComment}/${commentId}/${lectureID}`,
        { description: data }
    );
    return response;
};

export const createQuizAssessment = async (id, data) => {
    try {
        const response = await axiosAgent.post(
            `${ApiConfig.section.createLectureExcercise}/${id}`,
            { questions: data.questions }
        );
        return response;
    } catch (err) {
        console.log('err', err);
    }
};

export const getLectureExcercise = async (lectureId) => {
    try {
        const response = await axiosAgent.get(
            `${ApiConfig.section.getLectureExcercise}/${lectureId}`
        );
        return response.data;
    } catch (err) {
        console.log('err', err);
    }
};

export const deleteLectureExcercise = async (excerciseId) => {
    try {
        const response = await axiosAgent.delete(
            `${ApiConfig.section.deleteLectureExcercise}/${excerciseId}`
        );
        return response.data;
    } catch (err) {
        console.log('err', err);
    }
};

export const editReply = async (replyId, data) => {
    const response = await axiosAgent.post(
        `${ApiConfig.comments.editReply}/${replyId}`,
        { description: data }
    );
    return response;
};

export const getCourseModule = async (courseId, signal) => {
    const config = signal ? { signal } : {};
    const response = await axiosAgent.get(
        `${ApiConfig.course.getCourseModule}${courseId}`,
        config
    );
    return response.data;
};
